import {Component, Input, OnInit} from '@angular/core';
import {MetricInfo} from '../../models/metrics/metric-info';

@Component({
    selector: 'app-circle-progress-bar',
    templateUrl: './circle-progress-bar.component.html',
    styleUrls: ['./circle-progress-bar.component.scss'],
    standalone: false
})
export class CircleProgressBarComponent implements OnInit {

  @Input() metricInfo: MetricInfo;
  percent: number;

  constructor() {
  }

  ngOnInit(): void {
    // Wait for the main thread to finish to enforce animation.
    setTimeout(() => this.percent = this.metricInfo.percentage);
  }

}
